import { render, staticRenderFns } from "./CheckPayPageComponent.vue?vue&type=template&id=197fb8c4&scoped=true&"
import script from "./CheckPayPageComponent.vue?vue&type=script&lang=js&"
export * from "./CheckPayPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./CheckPayPageComponent.vue?vue&type=style&index=0&id=197fb8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fb8c4",
  null
  
)

export default component.exports